import { useDispatch } from 'react-redux';

import { setStateValue, setTipoPromocaoData } from '../../../../../../actions/actionsModuloRelatorio';
import { changeValue, setFiltrosSalvos } from '../../../../../../actions/actionsPainelGeral';
import { moduleReportReverseModelType } from '../../utils';

const DIMENSOES_IGNORADAS = new Set([
  'GTIN',
  'REGIAO',
  'LOJA',
  'LOGRADOURO',
  'PRECO_MINIMO',
  'PRECO_MAXIMO',
  'PRECO_MAIS_FREQUENTE',
  'PRECO_MEDIO',
  'QUANTIDADE_DADOS',
  'QUANTIDADE_LOJAS',
  'QUANTIDADE_REDES',
  'TIPO_PROMOCAO',
  'ANUNCIO_FLAG',
  'CONTEUDO_GRAMATURA',
  'ULTIMO_PRECO',
  'CNPJ',
]);

type SavedData = {
  produto?: string[];
  enderecoDTO?: {
    endereco?: string;
  };
  cnpj?: string[];
  [key: string]: any;
  dimensoes?: Array<{
    dimensao?: {
      name?: string;
    };
    [key: string]: any;
  }>;
};

type Method = {
  setProductsForEdition: (produtos: string) => void;
  enderecoHandlers: {
    handleSetValuesForEditEndereco: (endereco: { label: string; value: string }) => void;
  };
};

type ModelKey = string;

type UseSavedFiltersForEditionProps = {
  handleSetDimensoesFilters: (savedData: SavedData) => void;
};

export const useSavedFiltersForEdition = (method: Method): UseSavedFiltersForEditionProps => {
  const dispatch = useDispatch();

  const handleGTIN = (savedData: SavedData): void => {
    if (savedData?.produto?.length) {
      const produtos = savedData.produto.join(' ');
      dispatch(setStateValue('filterProductEditionLoading', true));
      method.setProductsForEdition(produtos);
    }
  };

  const handleTipoPromocao = (savedData: SavedData, modelKey: ModelKey): void => {
    dispatch(setTipoPromocaoData('edit', savedData[modelKey]));
  };

  const handleLogradouro = (savedData: SavedData): void => {
    const endereco = savedData.enderecoDTO?.endereco;
    if (endereco) {
      method.enderecoHandlers.handleSetValuesForEditEndereco({ label: endereco, value: endereco });
    }
  };

  const handleCNPJ = (savedData: SavedData): void => {
    const cnpjs = savedData.cnpj?.map((cnpj: string) => ({ label: cnpj, value: cnpj })) || [];
    dispatch(
      setStateValue('cnpj', {
        lista: cnpjs,
        cache: cnpjs,
        value: savedData.cnpj,
      }),
    );
  };

  const handleGenericFilters = (savedData: SavedData, modelKey: ModelKey): void => {
    const filtros = savedData[modelKey];
    if (filtros?.length) {
      filtros.forEach((filtro: any) => {
        dispatch(setFiltrosSalvos(modelKey, filtro));
      });
      dispatch(changeValue(filtros, modelKey));
    }
  };

  const handleSetDimensoesFilters = (savedData: SavedData): void => {
    savedData?.dimensoes?.forEach(item => {
      const key = item.dimensao?.name;
      if (!key) return;

      const modelKey = moduleReportReverseModelType[key as keyof typeof moduleReportReverseModelType];

      const handlers: Record<string, () => void> = {
        GTIN: () => handleGTIN(savedData),
        TIPO_PROMOCAO: () => handleTipoPromocao(savedData, modelKey),
        LOGRADOURO: () => handleLogradouro(savedData),
        CNPJ: () => handleCNPJ(savedData),
      };

      if (handlers[key]) {
        handlers[key]();
      } else if (!DIMENSOES_IGNORADAS.has(key)) {
        handleGenericFilters(savedData, modelKey);
      }
    });
  };

  return {
    handleSetDimensoesFilters,
  };
};
